export default "__VITE_ASSET__BuXNWnfK__"